var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "cookie-banner-slide" } }, [
    _vm.visible
      ? _c("div", { staticClass: "cookie-banner" }, [
          _c("div", { staticClass: "cookie-banner__content" }, [
            _c(
              "p",
              { staticClass: "cookie-banner__text" },
              [
                _vm._v(
                  "\n        Utilizamos Cookies propias y de terceros para analizar el uso del Sitio Web y, en su caso, mostrar publicidad\n        personalizada en función de un perfil elaborado a partir de los hábitos de navegación del Usuario.\n        El Usuario puede aceptar todas las Cookies, rechazarlas o consultar más información en nuestra\n        "
                ),
                _c(
                  "router-link",
                  {
                    staticClass: "cookie-banner__link",
                    attrs: { to: "/cookies" },
                  },
                  [_vm._v("Política de Cookies")]
                ),
                _vm._v(".\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cookie-banner__actions" }, [
              _c(
                "button",
                {
                  staticClass: "cookie-banner__btn cookie-banner__btn--reject",
                  on: { click: _vm.reject },
                },
                [_vm._v("Rechazar todo")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "cookie-banner__btn cookie-banner__btn--accept",
                  on: { click: _vm.accept },
                },
                [_vm._v("Aceptar todo")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }